import React, { useEffect, useState } from "react";
import "./CohortList.scss";
import SuggestedCohort from "./SuggestedCohort";
import CustomCohort from "./CustomCohort";
import {
  useGetCohortDetailsListQuery,
} from "../../../../rtk-query/features/cohort/cohortRTK";
import {
  resetCohort,
  setAssetSize,
  setClearAll,
  setCohortApplied,
  setMode,
  setResetSearchTextForAdditionalInstitutions,
  setSelectedAdditionalInstitutions,
  setSelectedCities,
  setSelectedCohort,
  setSelectedInstitutions,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import { Skeleton } from "primereact/skeleton";
import useFetch from "../../../../rtk-query/features/useFetch";

export const COHORT_MODE = {
  SUGGESTED: "suggested",
  CUSTOM: "custom",
};

// Recursively convert an object into a searchable flat string
const flattenObject = (obj) => {
  let result = "";
  for (const key in obj) {
    const value = obj[key];

    if (value === null || value === undefined) continue;

    if (typeof value === "object") {
      result += " " + flattenObject(value); // recurse
    } else {
      result += " " + String(value);
    }
  }
  return result;
};

// Deep Search in array of objects
const deepSearch = (list, searchText) => {
  const q = searchText.toLowerCase();
  return list?.filter((item) => {
    const flattened = flattenObject(item).toLowerCase();
    return flattened.includes(q);
  });
};

const CohortList = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [filteredCohort, setFilteredCohort] = useState([]);
  const [isCustomLoading, setIsCustomLoading] = useState(false);
  const mode = useSelector((state) => state?.cohortReducer?.mode);
  const clearAll = useSelector((state) => state?.cohortReducer?.clearAll);

  useEffect(() => {
    setIsCustomLoading(true);
  }, [mode]);

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const {
    data: cohortList,
    isError: isErrorCohortList,
    isLoading: isLoadingCohortList,
  } = useFetch(useGetCohortDetailsListQuery, {
    queryParams: { isDefault: mode === COHORT_MODE.SUGGESTED ? true : false },
  });

  useEffect(() => {
    if (cohortList?.data?.data?.length > 0 && selectedCohort != null) {
      const cohortMatchFound =
        cohortList?.data?.data?.find((i) => i.uid === selectedCohort?.uid) ||
        null;
      if (cohortMatchFound != null) {
        dispatch(setSelectedCohort(cohortMatchFound));
      }
    }
  }, [cohortList]);

  useEffect(() => {
    setFilteredCohort(
      deepSearch(
        cohortList?.data?.data,
        // [],
        searchText,
      ),
    );
    setIsCustomLoading(false);
  }, [cohortList, searchText]);

  return (
    <div className="cohort-list">
      <h3>Cohort List</h3>
      <div className="header-section">
        {!isLoadingCohortList ? (
          <div className="select-field">
            <FiSearch className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="Search cohort by name"
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        ) : (
          <div className="select-field">
            <Skeleton height="3rem" />
          </div>
        )}
        {!isLoadingCohortList ? (
          <button
            className="add-btn"
            onClick={() => {
              dispatch(setClearAll(true));
              dispatch(setCohortApplied(null));
              dispatch(setSelectedCohort(null));
              dispatch(setSelectedInstitutions([]));
              dispatch(setResetSearchTextForAdditionalInstitutions(false));
              dispatch(setSelectedAdditionalInstitutions([]));
              dispatch(
                setAssetSize({
                  minValue: null,
                  maxValue: null,
                }),
              );
              dispatch(setSelectedCities([]));
            }}
          >
            + Cohort
          </button>
        ) : (
          <div className="select-field" style={{ maxWidth: "10rem" }}>
            <Skeleton height="3rem" />
          </div>
        )}
      </div>
      {!isLoadingCohortList ? (
        <div className="tabs">
          <button
            className={`${mode === COHORT_MODE.SUGGESTED ? "active" : ""}`}
            onClick={(e) => {
              dispatch(setMode(COHORT_MODE.SUGGESTED));
              dispatch(setCohortApplied(null));
            }}
          >
            Suggested Cohort
          </button>
          <button
            className={`${mode === COHORT_MODE.CUSTOM ? "active" : ""}`}
            onClick={(e) => {
              dispatch(setMode(COHORT_MODE.CUSTOM));
              dispatch(setCohortApplied(null));
            }}
          >
            Custom Cohort
          </button>
        </div>
      ) : (
        <div className="tabs">
          <div className="select-field">
            <Skeleton height="3rem" />
          </div>
          <div className="select-field">
            <Skeleton height="3rem" />
          </div>
        </div>
      )}

      {!isLoadingCohortList && !isCustomLoading ? (
        mode === COHORT_MODE.SUGGESTED ? (
          <SuggestedCohort cohortList={filteredCohort} />
        ) : (
          <CustomCohort cohortList={filteredCohort} />
        )
      ) : (
        <div className="list-cohort flex-start">
          {[...Array(2)].map((_, i) => (
            <div className="skeleton-card">
              <Skeleton
                width="100%"
                height="241px"
                style={{ marginBottom: "24px" }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CohortList;
